export default "__VITE_ASSET__Db2CvAXl__"